var base = require('settings/preferences/lkq');
Vue.component('spark-preferences-lkq', {
    mixins: [base]
});
